/* app reference is autoloaded */
declare global {
	const app : MPAEngineApplication.Component;

	interface Window {
		app : MPAEngineApplication.Component;
	}
}
;
import './onlyForAppStyles.scss';
import { MPAEngineApplication } from './components';
await MPAEngineApplication.Component.run();
